module.exports = __webpack_public_path__ + "img/202206141241473023l4.402610eb.jpg";